import React, { useEffect } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}
export function Modal({
  open,
  title,
  onClose,
  children
}: ModalProps) {
  const reduce = useReducedMotion();
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-60" data-mp="170w5y7zk3g">
      {open && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-61" data-mp="28lp251fkyd">
          <motion.button type="button" aria-label="Закрыть" onClick={onClose} className="bg-overlay absolute inset-0 cursor-default" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-62" data-mp="4ygxq6nxuy1b" />
          <motion.div role="dialog" aria-modal="true" aria-label={title} className="bg-paper border-line relative max-h-[88dvh] w-full max-w-md overflow-y-auto border p-5 shadow-2xl sm:p-6" initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        scale: 0.97,
        y: 8
      }} animate={reduce ? {
        opacity: 1
      } : {
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        scale: 0.98,
        y: 4
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-63" data-mp="2r9q7gywioca1">
            <div className="mb-5 flex items-start justify-between gap-4" data-id="element-64" data-mp="30bfyw4qefb7t">
              <h2 className="text-ink text-base font-semibold tracking-tight" data-id="element-65" data-mp="309dcrvsda28d">{title}</h2>
              <button type="button" onClick={onClose} aria-label="Закрыть" className="text-muted hover:text-ink transition-colors duration-150 ease-swift" data-id="element-66" data-mp="1mqyisxhbqn6">
                <XIcon className="h-4 w-4" data-id="element-67" data-mp="1w1ekc8whz4vr" />
              </button>
            </div>
            {children}
          </motion.div>
        </div>}
    </AnimatePresence>;
}